import {
  ICategoriesWithProductsList,
  IFinalProductProps,
} from '@/interfaces/products';

export const OrganizeProductsByCategory = (
  products: IFinalProductProps[],
  productsPT?: IFinalProductProps[],
  notListedPackagesIds?: string[]
) => {
  let productsWithoutCategory: IFinalProductProps[] = [];
  let productsInCategoryObject: ICategoriesWithProductsList = {};

  for (let i in products) {
    let product = products[i];
    let productPT = productsPT ? productsPT![i] : null;

    const shouldSkipPackage =
      product.packageId &&
      notListedPackagesIds &&
      notListedPackagesIds.includes(product.packageId);

    if (shouldSkipPackage) {
      continue;
    }

    if (product.packageId) {
      product.categories = [
        {
          name: 'Pacotes',
          id: 'packages-category-id',
          createdAt: new Date(),
        },
      ];
    }

    if (product.categories?.length === 0) {
      productsWithoutCategory.push(product);
    } else {
      for (let i in product.categories || []) {
        let category = product.categories![i];
        let categoryPT = productPT ? productPT.categories![i] : null;

        let categoryName: string = category.name ? category.name : '';
        let categoryNamePT: string =
          categoryPT && 'name' in categoryPT ? categoryPT.name : '';

        if (!productsInCategoryObject[categoryName]) {
          productsInCategoryObject[categoryName] = {
            name: categoryName,
            menu: categoryName,
            categoryName,
            categoryNamePT,
            url: `/${categoryName}`,
            products: [],
            isCategory: true,
          };
        }

        productsInCategoryObject[categoryName].products.push(product);
      }
    }
  }
  let categoriesWithProducts = Object.keys(productsInCategoryObject).map(
    (key) => productsInCategoryObject[key]
  );

  return {
    productsWithoutCategory,
    categoriesWithProducts,
  };
};
